import React, { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import HomeContent from "@/components/HomeContent";
import CalculatorSection from "@/components/CalculatorSection";
import Footer from "@/components/Footer";

const Index = () => {
  useEffect(() => {
    document.title = "Skadisfinity Layout";
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        "content",
        "Plan printable Skadis-style board layouts with printer build-volume checks, print profiles, visual previews, and trim calculations."
      );
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <Header />
      <main className="container mx-auto px-4 py-16">
        <Hero />
        <Features />
        <HowItWorks />
        <HomeContent />
        <CalculatorSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
